actions =
  setLayout: (context, layout) ->
    new Promise (resolve, reject) ->
      context.commit('layout', layout)
      resolve()


`export default actions`
